import React, { useState, SFC, useEffect } from "react";
import { Select, MenuItem } from "@material-ui/core";

import { states } from "../../Constants/locations";

// eslint-disable-next-line react/prop-types
const Location = ({handleChange, handleCustomChange = null, label="", value="", margin="none", className="", inputClassName="", placeholder="placeholder"})  => {
    const [state, setState] = useState(value);
    const changeFunc = ({target: {value}}) => {
        setState(value);
        if(handleCustomChange) handleCustomChange(value);
        if(handleChange) handleChange(value);
    };

    useEffect(() => {
        setState(value);
    }, [value]);

    return (
        <Select
            labelId="select-outlined-label"
            variant="outlined"
            label={label}
            value={state}
            className={className}
            onChange={changeFunc}
            fullWidth
            style={{width: "100%"}}
            // margin={margin as "none" || "dense"}
            placeholder={placeholder}
            inputProps={{style: {width: "100%"}}}
        >
            {states.map((item, idx) => <MenuItem  key={`${item}_${idx}`} value={item.value}>{item.label}</MenuItem>)}

        </Select>
    );
};

export default Location;
